export default __webpack_public_path__ + "media/harmony.acaf2750.jpg";